import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HKCallback = () => {
  const location = useLocation();
  const room_uuid = location.pathname.split("/")[1];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const message = params.get("message");

    const returnPath =
      sessionStorage.getItem("hk_return_path") || `/${room_uuid}/house_keeping`;
    sessionStorage.removeItem("hk_return_path");

    const target =
      status === "true"
        ? `/${room_uuid}/HKOrderPlaced`
        : `${returnPath}?payment=failed${
            message ? `&message=${encodeURIComponent(message)}` : ""
          }`;

    try {
      // Same origin, so window.top is reachable when embedded.
      window.top.location.href = target;
    } catch (e) {
      window.location.href = target;
    }
  }, []);

  return <></>;
};

export default HKCallback;
